import React from 'react';
import WhatWeDoPage from '../components/WhatWeDoPage';

const Research = () => {
  const content = (
    <>
      <h2>Evidence-Based Research & Strategic Consulting</h2>
      <p>
        Our research helps us understand community needs and identify effective solutions. By gathering
        evidence and insights, we ensure that our programs are practical, relevant, and impactful. We
        provide guidance and expertise to organizations and institutions working in social development.
      </p>

      <h3>Research Services</h3>

      <h4>Quantitative and Qualitative Research</h4>
      <p>
        We conduct comprehensive research using participatory methods that engage communities and
        stakeholders. Our approach combines quantitative data analysis with qualitative insights to
        provide a complete understanding of complex social issues.
      </p>

      <h4>Need Assessment and Situational Analysis</h4>
      <p>
        Understand the current landscape before designing interventions. Our needs assessments and
        situational analyses provide the foundation for evidence-based program design and implementation.
      </p>

      <h4>Impact Assessment and Evaluation Studies</h4>
      <p>
        Measure the effectiveness and outcomes of development programs. Our impact assessments help
        organizations understand what works, what doesn't, and how to improve future interventions.
      </p>

      <h4>Social Audits</h4>
      <p>
        Ensure transparency and accountability in program implementation through comprehensive social
        audits. We help organizations assess compliance, effectiveness, and community satisfaction.
      </p>

      <h4>Action Research</h4>
      <p>
        Engage in participatory action research that combines inquiry with action to solve practical
        problems and improve programs in real-time.
      </p>

      <h4>Training Programme on Research Methodology</h4>
      <p>
        Build research capacity within your organization through our specialized training programs on
        research methodology, data collection, and analysis.
      </p>

      <h3>Consulting Services</h3>

      <h4>Strategic Planning & Project Management</h4>
      <p>
        Comprehensive consulting services in various aspects of management including:
      </p>
      <ul>
        <li>Strategic Planning and Vision Development</li>
        <li>Project Planning and Implementation</li>
        <li>Process Re-engineering</li>
        <li>Scaling Up of Operations</li>
        <li>Organizational Development</li>
      </ul>

      <h4>Monitoring and Evaluation</h4>
      <p>
        Design and implement robust monitoring and evaluation frameworks to track program progress,
        measure outcomes, and inform decision-making.
      </p>

      <h4>Development/Perspective Plans</h4>
      <p>
        Create comprehensive development plans that provide strategic direction and actionable roadmaps
        for organizations and communities.
      </p>

      <h4>Campaign Development and Rollout</h4>
      <p>
        From concept to implementation, we support the development and rollout of behavior change and
        advocacy campaigns.
      </p>

      <h4>Corporate Social Responsibility (CSR) Project Management</h4>
      <p>
        Design, implement, and manage CSR initiatives that create meaningful social impact while
        aligning with corporate values and objectives.
      </p>

      <h3>Our Approach</h3>
      <ul>
        <li>Participatory Methods: Engaging stakeholders throughout the research process</li>
        <li>Evidence-Based: Grounding recommendations in solid data and analysis</li>
        <li>Practical Solutions: Focusing on actionable insights and implementable strategies</li>
        <li>Capacity Building: Transferring knowledge and skills to partner organizations</li>
      </ul>
    </>
  );

  return (
    <WhatWeDoPage
      title="Research & Consulting"
      description="Evidence-Based Research and Strategic Advisory Services"
      content={content}
      image="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600"
    />
  );
};

export default Research;
